class Matcher {
    projectName;
    mcsRunEnv;
    constructor(params = {}) {
        const { projectName, mcsRunEnv } = params;
        this.projectName = projectName;
        this.mcsRunEnv = mcsRunEnv;
    }
    matches(setting, context = {}) {
        const filters = setting.filter;
        const { url, path, email, ip, sessionId, instanceId } = context;
        if (!filters) {
            return true;
        }
        const filterKeys = Object.keys(filters);
        return filterKeys.every(filter => {
            const criteria = String(filters[filter]);
            switch (filter) {
                case 'application':
                    return match(this.projectName, criteria);
                case 'environment':
                    return matchEnvironment(criteria);
                case 'server':
                    return false;
                case 'url':
                    return match(url, criteria);
                case 'host':
                    return false;
                case 'url-path':
                    return match(path, criteria);
                case 'email':
                    return match(email, criteria);
                case 'ip':
                    return match(ip, criteria);
                case 'context':
                    return matchContext(context.context, criteria);
                case 'mcs_run_env':
                    return match(this.mcsRunEnv, criteria);
                case 'in_browser':
                case 'unique_by_request':
                    return true;
                /** @deprecated {@link 'instance-id'} */
                case 'request-id':
                    return matchEqual(context.requestId, criteria);
                case 'session-id':
                    return matchEqual(sessionId, criteria);
                case 'instance-id':
                    return matchEqual(instanceId, criteria);
                default:
                    return false;
            }
        });
    }
}
function matchEnvironment(condition) {
    return matchSet({
        set: process.env,
        condition,
        useUppercaseNames: true,
    });
}
function matchContext(userCtx, condition) {
    return matchSet({
        set: userCtx,
        condition,
        useUppercaseNames: false,
    });
}
function matchSet(params) {
    const { set, condition, useUppercaseNames } = params;
    if (typeof set !== 'object') {
        return false;
    }
    if (typeof condition !== 'string') {
        return false;
    }
    const parts = condition.split(',').map(str => str.trim());
    if (!parts.length) {
        return false;
    }
    return parts.every((filter) => {
        const [filterName, filterValue] = filter.split('=');
        const setValue = set[useUppercaseNames ? filterName.toUpperCase() : filterName];
        return match(setValue, filterValue);
    });
}
function match(value, criteria) {
    if (!value || !criteria) {
        return false;
    }
    return RegExp(criteria).test(value);
}
function matchEqual(value, criteria) {
    if (!value || !criteria) {
        return false;
    }
    return criteria === value;
}

export { Matcher };
//# sourceMappingURL=matcher.mjs.map
